import * as actionTypes from './actionTypes';
import axios from '../../services/axios'
import  { setMessage } from './message'

export const loadDepartmentEmployees = () => {
    return {
        type: actionTypes.LOAD_DEPARTMENT_EMPLOYEES
    }
}

export const setDepartmentEmployees = (employees) => {
    return {
        type: actionTypes.SET_DEPARTMENT_EMPLOYEES,
        employees: employees
    }
}

export const setDepartmentName = (departmentName) => {
    return {
        type: actionTypes.SET_DEPARTMENT_NAME,
        departmentName: departmentName
    }
}

export const getDepartmentEmployees = (id) => {
    return (dispatch) => {
        dispatch(loadDepartmentEmployees())
        axios.get( `/api/v1/departments/name?id=${id}` )
            .then( response => {
                dispatch( setDepartmentName(response.data))
                axios.get( `/api/v1/employees?departmentId=${id}` )
                .then( response => {
                   dispatch( setDepartmentEmployees(response.data))
                } )
                .catch( error => {
                    dispatch( setDepartmentEmployees([]))
                    dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
                } );
            } )
            .catch( error => {
                dispatch( setDepartmentName(''))
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            } );
    }
}

export const loadEmployeeDetails = () => {
    return {
        type: actionTypes.LOAD_EMPLOYEE_DETAILS
    }
}

export const setEmployeeDetails = (employeeDetails) => {
    return {
        type: actionTypes.SET_EMPLOYEE_DETAILS,
        employeeDetails: employeeDetails
    }
}

export const setServerNotFoundEntity = (isNotFound) => {
    return {
        type: actionTypes.SERVER_NOT_FOUND_ENTITY,
        serverNotFoundEntity: isNotFound
    }
}

export const getEmployeeDetails = (urlId) => {
    return (dispatch) => {
        dispatch(loadEmployeeDetails())
        axios.get( `api/v1/employees/details-url?urlId=${urlId}` )
            .then( response => {
                dispatch( setEmployeeDetails(response.data))
            })
            .catch( error => {
                if ( error.response?.status === 404) {
                    dispatch(setServerNotFoundEntity(true))
                    dispatch(setServerNotFoundEntity(false))
                }
            });
    }
}